import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { Container, Typography, Tooltip, useTheme } from '@mui/material';
import CallSharpIcon from '@mui/icons-material/CallSharp';
import PhoneDisabledSharpIcon from '@mui/icons-material/PhoneDisabledSharp';
import { formatThousands } from '../../../Utils/constants/general';

const useStyles = makeStyles({
  icnWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    fontSize: '2rem',
  },
  captionValueWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
});

const ResultCallWidget = function ResultCallWidget({
  answered = 0,
  notAnswered = 0,
  answeredCount = 0,
  notAnsweredCount = 0,
  hideTooltip = false,
}) {
  const theme = useTheme();
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Container
      disableGutters
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <Tooltip
        title={hideTooltip ? '' : intl.messages.PERCENTAGE_ON_CALLS_MADE}
        placement="top"
        arrow
      >
        <div className={classes.captionValueWrap}>
          <Typography
            title={intl.messages.ANSWERED}
            noWrap
            sx={{
              color: theme.palette.greys.secondary,
            }}
          >
            {`${intl.messages.ANSWERED}`}
            <span
              style={{
                fontWeight: 'bold',
                fontSize: '24px',
                marginLeft: '4px',
              }}
            >
              {`(${formatThousands(answeredCount)})`}
            </span>
          </Typography>
          <div className={classes.icnWrap}>
            <CallSharpIcon
              sx={{ color: theme.palette.graphs.answered, fontSize: 'inherit' }}
            />
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.greys.secondary,
                fontSize: 'inherit',
              }}
            >
              {`${formatThousands(Math.round(answered) || 0)}%`}
            </Typography>
          </div>
        </div>
      </Tooltip>
      <Tooltip
        title={hideTooltip ? '' : intl.messages.PERCENTAGE_ON_CALLS_MADE}
        placement="top"
        arrow
      >
        <div className={classes.captionValueWrap}>
          <Typography
            title={intl.messages.NOT_ANSWERED}
            noWrap
            sx={{
              color: theme.palette.greys.secondary,
            }}
          >
            {`${intl.messages.NOT_ANSWERED}`}
            <span
              style={{
                fontWeight: 'bold',
                fontSize: '24px',
                marginLeft: '4px',
              }}
            >
              {`(${formatThousands(notAnsweredCount)})`}
            </span>
          </Typography>
          <div className={classes.icnWrap}>
            <PhoneDisabledSharpIcon
              sx={{
                color: theme.palette.graphs.notAnswered,
                fontSize: 'inherit',
              }}
            />
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.greys.secondary,
                fontSize: 'inherit',
              }}
            >
              {`${formatThousands(Math.round(notAnswered) || 0)}%`}
            </Typography>
          </div>
        </div>
      </Tooltip>
    </Container>
  );
};

ResultCallWidget.propTypes = {
  answered: PropTypes.number,
  notAnswered: PropTypes.number,
};

export default ResultCallWidget;
